import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { isAnythingSelected } from '../../../ducks/billItems';
import { openCloseBill } from '../../../ducks/navigation';

interface StateProps {
    disabled: boolean;
}

interface DispatchProps {
    closeBill: () => void;
}

interface OwnProps {
    billId: string;
    scope: string;
}

export const connectCloseButton = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        disabled: isAnythingSelected,
    }),
    (dispatch: CommanderThunkDispatch, { billId, scope }) => ({
        closeBill: () => dispatch(openCloseBill({ billId, scope })),
    })
);
